import 'css/src/global';

import React, { useCallback, useEffect, useState } from 'react';

import { ApiService, Urls } from 'js/src/client';
import { AuthQueryParams } from 'js/src/components/auth/auth-consts';
import Copyright from 'js/src/components/auth/common/Copyright';
import Sidebar from 'js/src/components/auth/common/Sidebar';
import Title from 'js/src/components/auth/common/Title';
import SSOSignupForm from 'js/src/components/auth/sso/SSOSignupForm';
import SSOVerificationForm from 'js/src/components/auth/sso/SSOVerificationForm';
import { Toast } from 'js/src/components/common/Toast';
import QueryString from 'js/src/libs/querystring';

const PageSkeleton = React.memo(function PageSkeleton() {
    return <div className="signup-skeleton"></div>;
});

const SSOVerificationPage = React.memo(function SSOVerificationPage() {
    const [isSignUp, setIsSignUp] = useState(false);
    const [signupEmail, setSignupEmail] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [pageTitle, setPageTitle] = useState('Log in via SSO');

    const fetchInvite = useCallback(function () {
        ApiService.authInvitationRetrieve({
            query: { uuid: QueryString[AuthQueryParams.INVITE_UUID] },
        })
            .then((response) => {
                const {
                    sender_first_name: inviter,
                    recipient_email: userEmail,
                    user_exists: userExists = false,
                } = response.data;
                if (!userExists) {
                    setPageTitle(`Get started with ${inviter}'s team by creating an account`);
                    setIsSignUp(true);
                }
                setSignupEmail(userEmail);
            })
            .catch(() => {
                Toast.error(
                    'Oops, looks like an invalid invitation link, Please check with your team Admin and try again.',
                );
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    useEffect(() => {
        QueryString[AuthQueryParams.INVITE_UUID] ? fetchInvite() : setIsLoading(false);
    }, [fetchInvite]);

    return (
        <div className="row">
            <div className="col-sm-4 d-none d-md-block">
                <Sidebar />
            </div>
            <div className="col-sm-8 col-xs-12 d-flex justify-content-center">
                <div className="details-form">
                    <div className="form-sidebar vertical-flex xs-fill-height">
                        <div className="flex-spacer">
                            {/* Spaces out top in the form on desktop */}
                            <div className="auth-base-logo d-block d-md-none mb-l5-48">
                                <a href="/">
                                    <img
                                        src="https://cdn.lumen5.com/lumen5-site-images/L5-logo/2024/Lumen5-PrimaryLogo.svg"
                                        alt="Lumen5"
                                        width="125"
                                    />
                                </a>
                            </div>
                        </div>
                        <div className="">
                            {isLoading ? (
                                <PageSkeleton />
                            ) : (
                                <>
                                    <Title title={pageTitle} />
                                    {isSignUp ? (
                                        <SSOSignupForm
                                            signupEmail={signupEmail}
                                            inviteId={QueryString[AuthQueryParams.INVITE_UUID]}
                                        />
                                    ) : (
                                        <SSOVerificationForm
                                            initialEmail={signupEmail}
                                            inviteId={QueryString[AuthQueryParams.INVITE_UUID]}
                                        />
                                    )}
                                </>
                            )}
                        </div>
                        <div className="d-flex align-items-end mb-l5-48">
                            Don&apos;t have sso enabled?&nbsp;
                            <a
                                className="fw-semibold"
                                href={Urls.LOGIN}
                                title="Login with email and password"
                            >
                                Login with email & password
                            </a>
                        </div>
                        <Copyright />
                    </div>
                </div>
            </div>
        </div>
    );
});

export default SSOVerificationPage;
